export default {
    'diagram3b3-1': {
        'diagram-task': 'Complete the pyramid and identify whether the argument on the Key Line level is Inductive or Deductive',
        'fixed-answer': 'Firestone’s most important commitment was his initial move to Akron',
        'element_1_1': 'Mature, settled and conservative, unable to react quickly or respond to sudden shocks',
        'element_1_2': 'The rise and fall pattern of engineering technologies resembles the rise and fall of species in evolution',
        'element_1_3': 'Big and sluggish, unable to change, ripe for extinction',
        'element_1_4': 'Small, quick and agile during rapid growth and spectacular success',
        'element_1_5': 'Old and declining as new, small and quick alternatives move in to occupy the niche',
        'hint-title': 'Hint',
        'resubmit-title': 'Resubmit'
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3b3/diagram1/i18n/en.js